import React from 'react';
import PropTypes from 'prop-types';
import NavItemButton from '../NavItemButton';
import { hideOnClassName } from './helper';

const NavItem = ({ notifs, data, hideOn, customClassNav, qaTagName }) => (
  <div className={hideOnClassName(hideOn, customClassNav)} data-qa={qaTagName}>
    <NavItemButton notifs={notifs} data={data} />
  </div>
);


NavItem.propTypes = {
  hideOn: PropTypes.string,
  customClassNav: PropTypes.string,
  notifs: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  data: PropTypes.shape({
    link: PropTypes.string,
    icon: PropTypes.string,
    labels: PropTypes.shape({
      large: PropTypes.string,
      small: PropTypes.string,
      icon: PropTypes.shape({
        max: PropTypes.string,
      }),
    }),
  }).isRequired,
  qaTagName: PropTypes.string,
};

NavItem.defaultProps = {
  hideOn: '',
  customClassNav: '',
  notifs: null,
  qaTagName: '',
};

export default NavItem;
